export default __webpack_public_path__ + "static/media/Graduate3.76dea792.svg";